import React from 'react';
import { Button } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';
import DeleteGroupButton from 'components/widgets/ProjectGroupEdit/EditFiltersStep/DeleteGroupButton';
import SaveGroupButton from 'components/widgets/ProjectGroupEdit/EditFiltersStep/SaveGroupButton';
import { useNavigateBackToDashboard } from 'hooks/projectGroupEdit/useProjectGroupForm';
import { useDashboardGroupId } from 'state/dashboard';

const menuStyle = {
  columnGap: 'padding_32',
};

const saveGroupStyle = {
  width: '208px',
};

type MainMenuProps = {
  saveButtonRef?: React.RefObject<HTMLButtonElement>;
  // AI saved searches are edited through the chat, not the filter form, so
  // there's nothing to manually "Update" - offer a plain exit instead.
  isChatEditor?: boolean;
};

const MainMenu = ({ saveButtonRef, isChatEditor = false }: MainMenuProps) => {
  const { navigateBackToDashboard } = useNavigateBackToDashboard();
  const [groupId] = useDashboardGroupId();

  return (
    <FlexRow sx={menuStyle}>
      <DeleteGroupButton />
      {isChatEditor ? (
        <Button
          sx={saveGroupStyle}
          variant="primary"
          onClick={() => navigateBackToDashboard(Number(groupId))}
        >
          Finish editing
        </Button>
      ) : (
        <SaveGroupButton ref={saveButtonRef} sx={saveGroupStyle} />
      )}
    </FlexRow>
  );
};

export default MainMenu;
